/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { ILxsHeroHeaderData } from './lxs-hero-header.data';
import { ILxsHeroHeaderProps } from './lxs-hero-header.props.autogenerated';

export interface ILxsHeroHeaderViewProps extends ILxsHeroHeaderProps<ILxsHeroHeaderData> {}

/**
 *
 * LxsHeroHeader component
 * @extends {React.PureComponent<ILxsHeroHeaderProps<ILxsHeroHeaderData>>}
 */
class LxsHeroHeader extends React.PureComponent<ILxsHeroHeaderProps<ILxsHeroHeaderData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default LxsHeroHeader;
